<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <div id="page-content-wrapper">
      <TheTopmenu />
      <div class="container-fluid p-3">
        <div class="row m-1 bg-light py-2 px-1">
          <div class="col-12 col-sm-4 mt-1">
            <div>
              <label for="users_select">جستجوی کاربر</label>
              <multiselect
                v-model="userId"
                id="users_select"
                placeholder="شروع به نوشتن کنید"
                open-direction="bottom"
                :options="users"
                :searchable="true"
                :loading="isLoading"
                :options-limit="300"
                :max-height="600"
                :hide-selected="true"
                @search-change="getUsers"
              >
              </multiselect>
            </div>
          </div>
          <div class="col-12 col-sm-4">
            <label>انتخاب محصول</label>
            <Multiselect
              class="my-1"
              v-model="productId"
              mode="single"
              :searchable="true"
              :createTag="true"
              :options="productOptions"
            />
          </div>
          <div class="col-12 col-sm-4">
            <template v-if="sesssionsList">
              <label>انتخاب جلسه</label>
              <Multiselect
                class="my-1"
                v-model="sessionId"
                mode="single"
                :searchable="true"
                :createTag="true"
                :options="sesssionsList"
              />
            </template>
          </div>
          <div class="col-12 col-sm-2 p-2">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="enableDate"
            />
            <label class="p-1" for="name"> فعال سازی تاریخ </label>
          </div>
          <template v-if="enableDate">
            <div class="col-12 col-sm-3">
              <label for="name"> از تاریخ</label>
              <DatePicker id="from_date" name="from_date" v-model="from_date" />
            </div>
            <div class="col-12 col-sm-3">
              <label for="name"> لغایت</label>
              <DatePicker id="to_date" name="to_date" v-model="to_date" />
            </div>
            <div v-if="reports" class="col-12 col-sm-3 pt-3">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="showManualOkOrders"
                />
                <label class="form-check-label" for="flexSwitchCheckChecked">
                  نمایش فاکتور های دستی
                </label>
              </div>
            </div>
          </template>

          <div class="col-12 text-start">
            <button class="btn btn-primary" @click="getReport">جستجو</button>

            <span v-show="showSpin">
              <i class="fas fa-spinner fa-spin mt-3"></i>
            </span>
          </div>
        </div>

        <table v-if="mode == 'product'" class="table table-info">
          <thead>
            <tr class="table-dark">
              <th>ردیف</th>
              <th>کاربر</th>
              <th>نام کاربری</th>
              <th>تاریخ</th>
              <th>صندلی</th>
              <th>فاکتور</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in reports" :key="item.id">
              <tr v-if="item.user" >
                <td>{{ index + 1 }}</td>
                <td>
                  {{ item.user.first_name ? item.user.first_name : "" }}
                  {{ item.user.last_name }}
                </td>
                <td>{{ item.user.email }}</td>
                <td>{{ this.utils.toJalali(item.created_at) }}</td>
                <td>
                  <div v-if="item.product.type==='chairs'" >
                    <template v-for="record,index in item.productDetails" :key="record.id" >
                    <span class="badge bg-warning text-dark me-1" >
                      {{ record.chair_number }} 
                    </span>
                    {{ item.productDetails.length -1 === index ? '':',' }}
                    </template>
                  </div>
                </td>
                <td>
                  <button
                    class="btn btn-primary btn-sm"
                    @click="showOrder(item.orders_id)"
                  >
                    فاکتور شماره
                    {{ item.orders_id }}
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>

        <table
          v-if="mode == 'order' || mode == 'date'"
          class="table table-info"
        >
          <thead>
            <tr class="table-dark">
              <th>ردیف</th>
              <th>شماره فاکتور</th>
              <th>تاریخ</th>
              <th>وضعیت</th>
              <th>کاربر</th>
              <th>جمع</th>
              <th>توضیحات</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in reports" :key="item.id">
              <tr role="button" @click="toggleDetails(item.id)">
                <td>{{ index + 1 }}</td>
                <td>{{ item.id }}</td>
                <td>{{ this.utils.toJalali(item.updated_at) }}</td>
                <td>
                  {{ statusTranslate[item.order_status] }}
                  {{
                    item.order_status == "manual_ok"
                      ? "-" +
                        (item.saver_user.first_name
                          ? item.saver_user.first_name
                          : "") +
                        " " +
                        item.saver_user.last_name
                      : ""
                  }}
                </td>
                <td>{{ item.user.first_name }} {{ item.user.last_name }}</td>
                <td>{{ this.utils.monize(item.amount) }}</td>
                <td v-if="item.payments.length > 0">
                  {{ item.payments[0].sale_reference_id }}
                </td>
                <td v-else>{{ item.comment }}</td>
              </tr>
              <tr v-if="opened.includes(item.id)">
                <td colspan="8">
                  <OrderDetails :order="item" @refreshPage="getReport" />
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="orderModal"
    tabindex="-1"
    aria-labelledby="orderModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="orderModalLabel">مشاهده فاکتور</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <span v-if="showOrderSpin">
            <i class="fas fa-spinner fa-spin fs-1 mt-3"></i>
          </span>
          <OrderDetails v-if="selectedOrder" :order="selectedOrder" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheSidemenu from "../components/TheSidemenu";
import TheTopmenu from "../components/TheTopmenu";
import ArefApi from "../libs/api.js";
import Multiselect from "@vueform/multiselect";
import utils from "../libs/utils.js";
import OrderDetails from "../components/OrderDetails";

import DatePicker from "vue3-persian-datepicker";
import "vue3-persian-datepicker/dist/datepicker.min.css";
import jmoment from "moment-jalaali";
import * as Bootstrap from "bootstrap";

export default {
  name: "SaleReports",
  setup() {
    return {
      DatePicker,
    };
  },
  created() {
    this.arefApi = new ArefApi();
    this.utils = new utils();
    this.jmoment = jmoment;
    this.statusTranslate = {
      ok: "درگاه",
      manual_ok: "حسابداری",
    };
    this.getProductsList();
    this.today = this.jmoment().format("YYYY-MM-DD");
  },
  components: {
    TheSidemenu,
    TheTopmenu,
    Multiselect,
    OrderDetails,
  },
  data() {
    return {
      productsList: null,
      productOptions: null,
      productId: this.$route.params.productId
        ? this.$route.params.productId
        : null,
      sesssionsList: null,
      sessionId: null,
      userId: null,
      users: [],
      isLoading: false,
      showSpin: false,
      mode: null,
      reports: null,
      noFilterReports: null,
      opened: [],
      enableDate: false,
      from_date: null,
      to_date: null,
      orderId: null,
      showOrderSpin: false,
      selectedOrder: null,

      showManualOkOrders: true,
    };
  },
  methods: {
    getProductsList() {
      this.arefApi.getProductsIndex(1, true).then((res) => {
        this.productsList = res.data;
        this.productOptions = this.productsList.map((item) => {
          return { value: item.id, label: item.name };
        });
      });
    },

    getProductVideoSessions() {
      this.arefApi
        .getProductVideoSessions(this.productId, 1, true)
        .then((sesssionsList) => {
          this.sesssionsList = sesssionsList.data.map((item) => {
            return { value: item.id, label: item.name };
          });
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },

    getUsers(query) {
      if (query.length <= 2) {
        return;
      }
      this.isLoading = true;
      const formSearch = {
        name: query,
        email: null,
        per_page: "all",
      };
      this.users = [];
      this.arefApi
        .searchUser(formSearch)
        .then((resp) => {
          this.users = resp.data.map((item) => {
            return {
              value: item.id,
              label: `${item.first_name} ${item.last_name} ${item.email}`,
            };
          });
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },

    getReport() {
      if (!this.userId && !this.productId && !this.enableDate) {
        this.$swal.fire({
          title: "!خطا",
          text: `محصول یا کاربر را انتخاب نمایید`,
          icon: "warning",
          confirmButtonText: "متوجه شدم",
        });
        return;
      }
      this.showSpin = true;
      this.mode = this.userId ? "order" : "product";
      if (!this.enableDate) {
        this.from_date = null;
        this.to_date = null;
      } else {
        this.from_date = this.from_date ? this.from_date : this.today;
        this.from_date =
          this.from_date.indexOf("/") > -1
            ? jmoment(this.from_date, "jYYYY/jM/jD").format("YYYY-MM-DD")
            : this.from_date;
        this.to_date = this.to_date ? this.to_date : this.today;
        this.to_date =
          this.to_date.indexOf("/") > -1
            ? jmoment(this.to_date, "jYYYY/jM/jD").format("YYYY-MM-DD")
            : this.to_date;
        this.mode = "date";
      }
      const searchData = {
        mode: this.mode,
        users_id: this.userId,
        products_id: this.productId,
        product_detail_videos_id: this.sessionId,
        from_date: this.from_date,
        to_date: this.to_date,
      };
      this.arefApi
        .saleReport(searchData)
        .then((resp) => {
          this.noFilterReports = resp.data;
          this.reports = [...resp.data];
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        })
        .finally(() => {
          this.showSpin = false;
        });
    },

    toggleDetails(rowId) {
      const indexOfId = this.opened.indexOf(rowId);
      if (indexOfId >= 0) {
        delete this.opened[indexOfId];
        return;
      }
      this.opened.push(rowId);
    },

    openOrderModal(orderId) {
      this.orderId = orderId;
      var myModal = new Bootstrap.Modal(document.getElementById("orderModal"), {
        keyboard: true,
      });
      myModal.toggle();
    },

    showOrder(orderId) {
      this.showOrderSpin = true;
      this.selectedOrder = null;
      this.openOrderModal();
      this.arefApi
        .getAdminOrderDetails(orderId)
        .then((resp) => {
          this.selectedOrder = resp.data;
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        })
        .finally(() => {
          this.showOrderSpin = false;
        });
    },
  },
  watch: {
    productId: function (newVal) {
      this.sesssionsList = null;
      this.sessionId = null;
      if (!newVal) {
        return;
      }
      const foundProduct = this.productsList.find((item) => item.id == newVal);
      if (foundProduct.type == "video") {
        this.getProductVideoSessions();
      }
    },
    showManualOkOrders: function (newVal) {
      this.reports = null;
      let tmpReportData = [...this.noFilterReports];
      if (this.mode == "order" || this.mode == "date") {
        if (!newVal) {
          let result = tmpReportData.filter(
            (p) => p.order_status !== "manual_ok"
          );
          this.reports = [...result];
          return;
        }

        this.reports = [...tmpReportData];
      }
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>